module.exports = __webpack_public_path__ + "img/pocket_width_welt.c12dac32.png";